<template>
<ul class="navbar-nav  sidebar sidebar-dark accordion" id="accordionSidebar">
  
  <a class="sidebar-brand d-flex align-items-center justify-content-center my-5">
    <div class="sidebar-brand-icon rotate-n-15"></div>
    <div class="sidebar-brand-text mx-3">
      <img src="../assets/tribeid.png" height="30" alt="">
    </div>
  </a>

  <hr class="sidebar-divider my-0" />

  <li class="nav-item active" v-for="(link,key) in dashboard.links.sidebar" :key="key">
    <router-link class="nav-link" :to="link.route">
      <i :class="`${link.icon}`"></i>
      <span class="pl-2
      ">{{link.text}}</span>
    </router-link>
  </li>

  <hr class="sidebar-divider" />

  <!-- Sidebar Toggler (Sidebar) -->
  <div class="text-center d-none d-md-inline">
    <button class="rounded-circle border-0" id="sidebarToggle"></button>
  </div>
</ul>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name:'SideNav',
 computed: { ...mapGetters(["dashboard"]) },
  created() {
   
  }
}
</script>